import { Link } from './Router.tsx'
import { Modal } from './Modal.tsx'

interface OnboardingModalProps {
  isOpen: boolean
  onClose: () => void
}

export function OnboardingModal({ isOpen, onClose }: OnboardingModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      overlayClassName="bg-black/30"
      contentClassName="!p-4"
    >
          <div className="text-white leading-relaxed space-y-3 text-center">
            <p>
              Welcome to{' '}
              <span className="font-[Turret_Road] text-orange-500 text-[1.25em] font-bold leading-none">
                loopmaster
              </span>
              ! This is your live audio programming environment where you can create, experiment, and bring your musical
              ideas to life in real-time. We also have a{' '}
              <a href="https://discord.gg/NSWaB9dRYh" target="_blank" className="text-orange-500">
                Discord server
              </a>
              !
            </p>
          </div>
          <div className="flex gap-3 pt-2">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 text-sm border-none rounded-md cursor-pointer font-semibold bg-gradient-to-br from-orange-400 to-red-600 text-white hover:opacity-90"
            >
              Get started
            </button>
            <Link
              href="/tutorials"
              onClick={onClose}
              className="flex-1 px-4 py-2 text-sm border-none rounded-md cursor-pointer font-semibold bg-gradient-to-br from-blue-500 to-blue-700 text-white hover:opacity-90 text-center"
            >
              Read the Tutorials
            </Link>
          </div>
    </Modal>
  )
}
